import { render } from "./ProductFileUploader.vue?vue&type=template&id=3279e6ba"
import script from "./ProductFileUploader.vue?vue&type=script&lang=js"
export * from "./ProductFileUploader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\external\\kazigraphix\\admin.kazigraphix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__